import { Controller } from "@hotwired/stimulus"
import {
  Chart,
  BarController,
  BarElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
} from "chart.js"

Chart.register(
  BarController,
  BarElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
)

// data-controller="top-users-chart"
// data-top-users-chart-labels-value='["John Doe", "Jane Smith", ...]'
// data-top-users-chart-datasets-value='[{"label":"Gym A","data":[13,0,5,...]},{"label":"Gym B","data":[17,8,0,...]}]'
export default class extends Controller {
  static values = {
    labels: Array,
    datasets: Array,
  }

  connect() {
    const canvas = this.element.querySelector("canvas") || this.element
    const colors = [
      "#3b82f6",
      "#ef4444",
      "#22c55e",
      "#f59e0b",
      "#8b5cf6",
      "#ec4899",
      "#06b6d4",
      "#84cc16",
    ]
    this.chart = new Chart(canvas.getContext("2d"), {
      type: "bar",
      data: {
        labels: this.labelsValue,
        datasets: this.datasetsValue.map((ds, i) => ({
          label: ds.label,
          data: ds.data,
          backgroundColor: colors[i % colors.length] + "cc",
          borderColor: colors[i % colors.length],
          borderWidth: 1,
        })),
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            mode: "index",
            intersect: false,
            callbacks: {
              label: (context) => {
                const count = context.parsed.y
                return count > 0 ? ` ${context.dataset.label}: ${count} visit${count !== 1 ? "s" : ""}` : null
              },
            },
          },
        },
        scales: {
          x: {
            stacked: true,
          },
          y: {
            stacked: true,
            beginAtZero: true,
            ticks: {
              stepSize: 1,
            },
          },
        },
      },
    })
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }
}
